import React, {useEffect, useRef, useState} from "react";
import {Button, Col, Form, Input, Row, Select, Spin, Pagination} from "antd";
import {certificatesSubject, getCertificates, useCertificates} from "../hooks/certificate";
import {useTranslation} from "react-i18next";
import {getTemplate, useTemplate} from "../hooks/template";
import {CertificateListItemDto, TemplateListItemDto} from "../generated-api";
import {CertificatesList} from "./CertificatesList";
import {ResponseSubjectState} from "../hooks";
import {XCircle} from "react-feather";
import {DEFAULT_PAGE_SIZE} from "../constants";
import { CertificatesListSearch } from "./CertificatesListSearch";

let searchTimeout: any;

export function SearchCertificates({show, header, multiSelect, addLinksButton, onClose, onClick}: { show: boolean, multiSelect: boolean, addLinksButton: boolean, header?: string, onClose: any, onClick: any }) {
    const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
    const {t} = useTranslation();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
    const [query, setQuery] = useState('');
    const [templateId, setTemplateId] = useState<any>(EMPTY_GUID);
    const searchResponse = useCertificates();
    const responseData = searchResponse.data || {};
    const certificates = responseData.items || [];
    const columns = responseData.columns || [];
    const onSelectMultipleCertificates = useRef<any>(null);
    const templateResponse = useTemplate();
    const templates: TemplateListItemDto[] = templateResponse.data || [];
    const totalCertificates = responseData.total || responseData.length;

    useEffect(() => {
        if (query && query.length >= 3) {
            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }
            console.log('search')
            searchTimeout = setTimeout(() => {
                getCertificates((page - 1) * pageSize, pageSize, templateId, query || undefined).then().catch(console.error);
            }, 500);
        } else {
            certificatesSubject.next(new ResponseSubjectState());
        }
    }, [templateId, query, page, pageSize]);
    
    useEffect(() => {
        if (!templateResponse.data) {
            getTemplate(true).then().catch(console.error);
        }
        certificatesSubject.next(new ResponseSubjectState());
    }, [true]);

    const reset = () => {
        certificatesSubject.next(new ResponseSubjectState());
        setTemplateId(EMPTY_GUID);
        setQuery('');
    };

    if (!show) {
        return null;
    }

    return (
        <div className={'search-certificates' + (header ? ' with-header' : '')}>
            {!!header && <header className="header flex-row">
                <h2 className={'flex-auto'}>{header}</h2>
                <Button type={'link'} onClick={onClose}>
                    <XCircle/>
                </Button>
            </header>}
            <div className={'top-block'}>
                <Form labelCol={{span: 11}} className={'search-form'}>
                    <Row className={'row-offset'}>
                        <Col span={24} md={12} xl={8}>
                            <Form.Item>
                                <Select placeholder={t('certificate.template')}
                                        defaultValue ={EMPTY_GUID}
                                        allowClear showSearch style={{width: '100%'}}
                                        onChange={value => {
                                            setTemplateId(value as any);
                                            setQuery('');
                                        }}
                                        filterOption={(input, option): any =>
                                            String((option || {}).children || '').toLowerCase().indexOf(String(input || '').toLowerCase()) >= 0
                                        }>
                                    {templates.map((item: any) =>
                                        <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24} md={12} xl={8}>
                            <Form.Item>
                                <Input disabled={!templateId} value={query} placeholder={t('general.search')}
                                       onChange={event => setQuery(event.target.value)}/>
                            </Form.Item>
                        </Col>
                        <Col span={24} md={12} xl={8}>
                            <Form.Item>
                                {addLinksButton && <Button type="primary" className={'white-background text-default'} disabled={!templateId} onClick={() => onSelectMultipleCertificates.current && onSelectMultipleCertificates.current()}>{t('certificates.addLinks')}</Button>}                                
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div className={'subpage-content'}>
                <Spin spinning={searchResponse.loading}>
                    
                    {
                        templateId !== EMPTY_GUID
                        ? <CertificatesList
                            certificates={(query && query.length >= 3) ? certificates : []}
                            columns={columns}
                            multiSelect={multiSelect}
                            onSelectMultipleCertificates={onSelectMultipleCertificates}
                            onClick={(certificate: CertificateListItemDto) => {
                                reset();
                                onClose();
                                onClick(certificate);
                            }}
                            />
                        : <CertificatesListSearch
                            certificates={(query && query.length >= 3) ? certificates : []}
                            multiSelect={multiSelect}
                            onSelectMultipleCertificates={onSelectMultipleCertificates}
                            onClick={(certificates: any) => {
                                reset();
                                onClose();
                                onClick(certificates);
                            }}
                        />
                    }

                {totalCertificates > pageSize &&
                    <Pagination showSizeChanger 
                        onChange={setPage} 
                        onShowSizeChange={(c, size) => setPageSize(size)} 
                        pageSize={pageSize} total={totalCertificates} 
                        current={page}
                        defaultCurrent={page}/>
                }
                   
                </Spin>
            </div>
        </div>
    );
}
